export default __webpack_public_path__ + "static/media/060_corner2.first.a7ce3d90.png";